import type { ReactElement } from 'react';
import { useCallback } from 'react';

import { usePostHog } from 'posthog-js/react';

import { useTitleObserver } from '@/hooks/useTitleObserver';

export function PostHogTrackingListener({ children }: { readonly children: ReactElement }) {
  const posthog = usePostHog();

  const handleTitleMutation = useCallback(
    (title: string, url: string) => {
      if (!posthog) return;
      posthog.capture('$pageview', {
        $current_url: url,
        $title: title
      });
    },
    [posthog]
  );

  useTitleObserver(handleTitleMutation);

  return children;
}
